import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-flex h-flex-space-between h-align-items-center h-width-100p" }
const _hoisted_2 = { class: "h-mr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[{ "active": _ctx.isActive }, { "active-error": _ctx.isActive && !_ctx.isStatusSuccess, "active-success": _ctx.isActive && _ctx.isStatusSuccess }], "b-bottom-hint"]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text), 1),
      _createVNode(_component_FwIcon, {
        class: "h-pointer",
        icon: "close",
        size: "15",
        color: "#fff",
        onClick: _withModifiers(_ctx.close, ["stop"])
      }, null, 8, ["onClick"])
    ])
  ], 2))
}